<!-- https://material.angular.dev/cdk/overlay/api#CdkConnectedOverlay -->
<!-- cdkConnectedOverlayDisableClose directive:  prevents automatic closing on outside click and ESC key -->
<!-- cdkTrapFocusAutoCapture directive: automatically focuses the first focusable element inside the overlay -->

<ng-content select="[agprOverlayTrigger]" ></ng-content>
<ng-template
    cdkConnectedOverlay
    #overlayDir="cdkConnectedOverlay"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="1"
    [cdkConnectedOverlayDisableClose]="true"
    (backdropClick)="closeOverlay()"
    (detach)="closeOverlay()">

    <div
        class="agpr-clickOutsideExcluded"
        role="dialog"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="!(initialFocusSelectors && initialFocusSelectors.length > 0)"
        >
        <ng-container *ngTemplateOutlet="target.tpl"></ng-container>
    </div>
</ng-template>
